import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVInput } from "../../../shared/JVInput";
import { JVDate } from "../../../shared/JVDate";
import { JVTime } from "../../../shared/JVTime";
import { ITrainingSchedules } from "./Table";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";

interface IProps {
    open: boolean,
    singleData: ITrainingSchedules,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

const schema = yup.object({
    form_ID: yup.number().required("Trainer Form is required*"),
    no_Of_Trainees: yup.number().min(1).required("No Of Trainees is required*").typeError("No Of Trainees is required and must be greater than 0"),
    branchName: yup.string().required("Branch is required*"),
    training_Date: yup.date().required("From Date is required*").typeError("Training Date is required"),
    training_Time_From: yup.date().required("Time From is required").typeError("Time From is required"),
    training_Time_To: yup.date().required("Time To is required").typeError("Time To is required"),
});

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [activeForms, setActiveForms] = useState<Array<{ form_ID: number, form_Status: boolean, form_Name: string }>>([]);
    const [branchs, setBranchs] = useState<Array<string>>([]);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ITrainingSchedules>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onHide = () => {
        setLoading(false);
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (data: ITrainingSchedules) => {
        if (new Date(data.training_Time_From || "").getHours() > new Date(data.training_Time_To || "").getHours()) {
            props.toast.current.show({ severity: 'error', detail: "Time From Can not be greater than Time To", life: 3000 });
        } else if (new Date(data.training_Time_From || "").getHours() === new Date(data.training_Time_To || "").getHours() && (new Date(data.training_Time_From || "").getMinutes() >= new Date(data.training_Time_To || "").getMinutes())) {
            props.toast.current.show({ severity: 'error', detail: "Time From Can not be greater than Time To", life: 3000 });
        } else {
            setLoading(true);
            const method = props.singleData.schedule_ID ? "PUT" : "POST";
            const message = props.singleData.schedule_ID ? "Updated Successfully" : "Added Successfully";
            const url = props.singleData.schedule_ID ? "updateTrainingSchedules" : "addTrainingSchedules";

            data.training_Time_From = new Date(format(new Date(data.training_Time_From || ""), "yyyy-MM-dd HH:mm:ss"));
            data.training_Time_To = new Date(format(new Date(data.training_Time_To || ""), "yyyy-MM-dd HH:mm:ss"));

            // data.training_Time_From = new Date(new Date().getFullYear(),
            //     new Date().getMonth(),
            //     new Date().getDate(),
            //     new Date(data.training_Time_From || "").getHours() - 5,
            //     new Date(data.training_Time_From || "").getMinutes(),
            //     new Date(data.training_Time_From || "").getSeconds());
            // data.training_Time_To = new Date(new Date().getFullYear(),
            //     new Date().getMonth(),
            //     new Date().getDate(),
            //     new Date(data.training_Time_To || "").getHours() - 5,
            //     new Date(data.training_Time_To || "").getMinutes(),
            //     new Date(data.training_Time_To || "").getSeconds());


            const response = await Fetch(("CarnivalTraining/" + url), method, data, null, props.toast);

            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            } else setLoading(false);
        }
    }

    const loadAcceptedForm = async () => {
        const res = await Fetch("CarnivalTraining/getAcceptedForm", "GET", null, `formID=${props.singleData.form_ID || 0}`, props.toast);
        if (res) {
            const data: { form_ID: number, form_Status: boolean, form_Name: string }[] = await res.json();
            setActiveForms(data);
        }
    }

    const loadBranchs = async () => {
        const res = await Fetch("CarnivalTraining/getBranchNames", "GET", null, null, props.toast);
        if (res) {
            const data: string[] = await res.json();
            setBranchs(data);
        }
    }

    useEffect(() => {
        if (props.open) {
            loadAcceptedForm();
            loadBranchs();
            if (props.singleData.schedule_ID) {
                reset({
                    ...props.singleData,
                    training_Date: new Date(props.singleData.training_Date || ""),
                    // training_Date_To: new Date(props.singleData.training_Date_To || ""),
                    training_Time_From: new Date(props.singleData.training_Time_From || ""),
                    training_Time_To: new Date(props.singleData.training_Time_To || ""),
                });
            } else reset(props.singleData);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Add/Edit Submission" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required label="Form" control={control} name="form_ID" options={activeForms} optionLabel="form_Name" optionValue="form_ID" placeholder="Select Trainer Form" error={errors.form_ID?.message} />
                <JVInput required label="No Of Trainees" type="number" control={control} name="no_Of_Trainees" error={errors.no_Of_Trainees?.message} />
                <JVDropdown required label="Branch" control={control} name="branchName" options={branchs} optionLabel="branchName" optionValue="branchName" placeholder="Select Branch" error={errors.branchName?.message} />
                <JVDate required column={2} label="Training Date" control={control} name="training_Date" />
                {/* <JVDate required column={4} label="To Date" control={control} name="training_Date_To" /> */}
                <JVTime column={2} label="Time From" required control={control} name="training_Time_From" error={errors.training_Time_From?.message} />
                <JVTime column={2} label="Time To" required control={control} name="training_Time_To" error={errors.training_Time_To?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}